import {cn} from '@tempmee/core'
import {type TextareaHTMLAttributes, forwardRef} from 'react'
import {inputTextAreaFieldVariants, textareaBaseClass} from './InputTextAreaFieldVariants'

export interface InputTextAreaFieldProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** Applies error styling (red border + background) */
  isError?: boolean
  /** Sets a specific initial height in pixels */
  height?: number
  /** Disables the textarea and applies the disabled background */
  disabled?: boolean
}

export const InputTextAreaField = forwardRef<HTMLTextAreaElement, InputTextAreaFieldProps>(
  ({className, isError, height, disabled, ...props}, ref) => {
    return (
      <div className={cn(inputTextAreaFieldVariants({isError, disabled}), className)}>
        <textarea
          ref={ref}
          className={textareaBaseClass}
          style={height !== undefined ? {height} : undefined}
          disabled={disabled}
          {...props}
        />
      </div>
    )
  },
)

InputTextAreaField.displayName = 'InputTextAreaField'
